/** The Space logo mark's pink chip — a yellow 4-point spark with an ink outline, sized to
 *  fill the square like the spark favicon. */
export function SparkChip() {
  return (
    <span className="chip" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M12 1 L14.8 9.2 L23 12 L14.8 14.8 L12 23 L9.2 14.8 L1 12 L9.2 9.2 Z" />
      </svg>
    </span>
  );
}
